import angular from 'angular';
import '../app.constants';
import '../services/auth';
import '../services/globals';

const module = angular.module('whyline.controllers.reset-password', [
  'whyline.constants',
  'whyline.services.auth',
  'whyline.services.globals',
]);

const ResetPasswordController = function (SAFE_STATES, $scope, $state, AuthService, NotificationService, GlobalsService, $translate) {
  'ngInject';

  $scope.enterpriseType = GlobalsService.EnterpriseType;
  $scope.currentYear = new Date().getFullYear();

  const showSignInError = () => {
    NotificationService.Error($translate.instant('err_reset_pw'));
  };

  $scope.reseted = false;

  const validatePassword = password => {
    const invalid = /\s/;

    if (invalid.test(password.toString())) {
      const message = $translate.instant('invalid_current_pw');
      NotificationService.Error(message);
      throw new Error(message);
    }
  };

  this.save = () => {
    if (this.password !== this.passwordRepeated) {
      NotificationService.Error($translate.instant('unmatch_pw'));
    } else {
      validatePassword(this.password);

      return AuthService.ResetPassword(this.password, $state.params.token)
        .then(res => {
          if (res === true) {
            $scope.reseted = true;
          } else if (res && res !== true) {
            $state.go(SAFE_STATES.organizationsList);
          } else {
            showSignInError();
          }
        })
        .catch(showSignInError);
    }
  };
};

module.exports = module.controller('ResetPasswordController', ResetPasswordController);
